"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellTowerRequest = exports.CellTowerInfo = exports.Address = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Location.Schema';
/**
 * `express-validator` `isFloat` accepts a number or a numeric string.
 * The handler stores whichever of the two arrived. A non-numeric string is 422.
 */
const floatString = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^(?![-+.]?$)[+-]?(?:\d+)?(?:\.\d*)?(?:[eE][+-]?\d+)?$/)).annotations({
    // fast-check cannot generate a lookahead. These are strings isFloat accepts.
    arbitrary: () => fc => fc.constantFrom('1', '1.', '.5', '1e10', 'e10', '5.0', '-2.5'),
});
const FloatValue = effect_1.Schema.Union(effect_1.Schema.Number, floatString).annotations({
    identifier: `${exports.NAMESPACE}.FloatValue`,
    description: 'A number, or a string isFloat accepts. A non-numeric string is 422.',
});
/** Installation address and contact fields. Every field is optional. */
exports.Address = effect_1.Schema.Struct({
    lat: effect_1.Schema.optionalWith(FloatValue, { exact: true }),
    lon: effect_1.Schema.optionalWith(FloatValue, { exact: true }),
    address: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    addressExtra: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    zip: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    city: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    state: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    country: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    mobilePhoneNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    phoneNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    email: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    contactName: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    customerAccountId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Address`,
});
const CellTower = effect_1.Schema.Struct({
    cellId: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    locationAreaCode: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    mobileCountryCode: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    mobileNetworkCode: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    age: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    signalStrength: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    timingAdvance: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CellTower`,
});
const WifiAccessPoint = effect_1.Schema.Struct({
    macAddress: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    signalStrength: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    age: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    channel: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    signalToNoiseRatio: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.WifiAccessPoint`,
});
/**
 * Google Geolocation request the handler forwards.
 * The handler itself only checks that `cellTowerInfo` is a non-empty object.
 */
exports.CellTowerInfo = effect_1.Schema.Struct({
    homeMobileCountryCode: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    homeMobileNetworkCode: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    radioType: effect_1.Schema.optionalWith(effect_1.Schema.Literal('gsm', 'cdma', 'wcdma', 'lte', 'nr'), { exact: true }),
    carrier: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    considerIp: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
    cellTowers: effect_1.Schema.optionalWith(effect_1.Schema.Array(CellTower), { exact: true }),
    wifiAccessPoints: effect_1.Schema.optionalWith(effect_1.Schema.Array(WifiAccessPoint), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CellTowerInfo`,
    description: 'Fields the handler forwards to the Google Geolocation API. ' +
        'The handler does not check them: notEmpty() stringifies an object, so {} is accepted.',
});
exports.CellTowerRequest = effect_1.Schema.Struct({
    cellTowerInfo: exports.CellTowerInfo,
}).annotations({
    identifier: `${exports.NAMESPACE}.CellTowerRequest`,
});
//# sourceMappingURL=schema.js.map